// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const ShoppingBagFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M20.12 6.71l-2.83-2.83A3 3 0 0015.17 3H8.83a3 3 0 00-2.12.88L3.88 6.71A3 3 0 003 8.83V18a3 3 0 003 3h12a3 3 0 003-3V8.83a3 3 0 00-.88-2.12zM12 16a4 4 0 01-4-4 1 1 0 112 0 2 2 0 104 0 1 1 0 112 0 4 4 0 01-4 4zM6.41 7l1.71-1.71A1.05 1.05 0 018.83 5h6.34c.265.004.518.107.71.29L17.59 7H6.41z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const ShoppingBagFillOffset: IconOffset = {
    vertical: 10,
    horizontal: 10,
};

export default React.memo(ShoppingBagFill);
